import { endOfDay } from "date-fns";
import startOfDay from "date-fns/startOfDay";
import { QueryFunctionContext } from "react-query";
import { JwtClient } from "utils/jwtClient";

export const getUsageDataCSV = async ({
  queryKey,
}: QueryFunctionContext<
  [
    string,
    { startAt: string; endAt: string; icpNumber: string; jwtClient: JwtClient },
  ]
>): Promise<string> => {
  const [_, { jwtClient, startAt, endAt, icpNumber }] = queryKey;
  const queryParams = {
    starting_at: startOfDay(new Date(startAt)),
    ending_at: endOfDay(new Date(endAt)),
    icp_number: icpNumber,
  };
  const response = await jwtClient.apiCall({
    path: "/telemetry/validated_measurements.csv",
    queryParams,
  });
  return await response.text();
};
